import { render, staticRenderFns } from "./ResourceCard.vue?vue&type=template&id=692719b2&scoped=true"
import script from "./ResourceCard.vue?vue&type=script&lang=js"
export * from "./ResourceCard.vue?vue&type=script&lang=js"
import style0 from "./ResourceCard.vue?vue&type=style&index=0&id=692719b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692719b2",
  null
  
)

export default component.exports